const ACCOUNT_STATUS = {
  ACTIVE: { title: '정상', color: 'green' },
  INACTIVE: { title: '비활성', color: 'orange' },
  DORMANT: { title: '휴먼', color: 'grey' },
  WITHDRAWN: { title: '탈퇴', color: 'red' },
};

const SIGNUP_PATH = {
  MEMBER: '일반가입',
  NAVER: '네이버',
  GOOGLE: '구글',
  APPLE: '애플',
  KAKAO: '카카오',
  NONE: '비회원',
};

const USER_SETTING = {
  location_consent: '위치정보 서비스 이용약관 동의',
  marketing_consent: '마케팅정보 수집 및 활용 동의',
  push_notification: '푸시알림',
  event_notification: '프로모션/이벤트 알림',
  terms_of_use: '이용약관 동의 여부',
  terms_of_privacy: '개인정보 수집 및 이용 동의 여부',
  terms_of_marketing: '마케팅 목적의 개인정보 수집 및 이용 동의 여부',
  terms_of_ad: '혜택 및 광고성 정보 수신 동의',
  terms_of_age: '만 14세 이하',
};

export { ACCOUNT_STATUS, SIGNUP_PATH, USER_SETTING };
